export default "__VITE_ASSET__8LO$Ki6p__"